/* global Stickyfill lozad */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll.js' // スムーズスクロール

import Swiper from 'swiper' // Swiper
import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー

// position:styckyのポリフィル
Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accordionBtn = 'spmenu' // このIDを基準としたアコーディオン
  $('#' + accordionBtn + '-open,#' + accordionBtn + '-close').on('click', function() {
    $('#' + accordionBtn + ',#' + accordionBtn + '-open,#' + accordionBtn + '-close').toggleClass('active')
    $('body').toggleClass('lock')
  })

  /*

        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##

*/

  /*

         ##     ## ##     ##
         ###   ### ##     ##
         #### #### ##     ##
 ####### ## ### ## ##     ##
         ##     ##  ##   ##
         ##     ##   ## ##
         ##     ##    ###

*/

  let topSwiper
  function gauge() {
    // ゲージを一からアニメーションさせ、完了したらスライド

    $('.swiper-gauge').each(function() {
      // 新しいゲージをアニメーションさせる
      $(this)
        .html('<div class="gauge gra"></div>')
        .on('animationend webkitAnimationEnd', function() {
          topSwiper.slideNext()
        })
    })
  }
  if ($('#top-mv')[0]) {
    // Swiperコンテナを検出したら実行

    // eslint-disable-next-line no-unused-vars
    topSwiper = new Swiper('#top-mv', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 50, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10,  //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      // slidesPerView: 5,   //表示数変更
      // spaceBetween: 20,   //スライド同士の間隔を空ける
      // freeMode: true,     //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true,      // スライドごとに高さを変動させる
      pagination: {
        // ページャーオプション
        el: '.mv-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function(index, className) {
          return '<div class="' + className + '"></div>'
        }
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        728: {}
      },
      on: {
        init: function() {
          gauge()
        }
      }
    })
    topSwiper.on(' slideNextTransitionStart slidePrevTransitionStart', function() {
      // スライド時のトリガー
      gauge()
    })
  }

  /*

        ######   ######  ##     ##  #######   #######  ##               ##     ## ##     ##
       ##    ## ##    ## ##     ## ##     ## ##     ## ##               ###   ### ##     ##
       ##       ##       ##     ## ##     ## ##     ## ##               #### #### ##     ##
        ######  ##       ######### ##     ## ##     ## ##       ####### ## ### ## ##     ##
             ## ##       ##     ## ##     ## ##     ## ##               ##     ##  ##   ##
       ##    ## ##    ## ##     ## ##     ## ##     ## ##               ##     ##   ## ##
        ######   ######  ##     ##  #######   #######  ########         ##     ##    ###

*/
  if ($('#school-mv')[0]) {
    // Swiperコンテナを検出したら実行

    // eslint-disable-next-line no-unused-vars
    topSwiper = new Swiper('#school-mv', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 50, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10,  //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      // slidesPerView: 5,   //表示数変更
      // spaceBetween: 20,   //スライド同士の間隔を空ける
      // freeMode: true,     //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true,      // スライドごとに高さを変動させる
      pagination: {
        // ページャーオプション
        el: '.mv-pagination', // ページャーを呼び出す要素
        type: 'fraction' // bullets,fraction(現ページ/ページ数),progressbar,custom
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        728: {}
      },
      on: {
        init: function() {
          gauge()
        }
      }
    })
    topSwiper.on(' slideNextTransitionStart slidePrevTransitionStart', function() {
      // スライド時のトリガー
      gauge()
    })
  }

  /*

         ######## ##     ## ######## ##    ## ########
         ##       ##     ## ##       ###   ##    ##
         ##       ##     ## ##       ####  ##    ##
 ####### ######   ##     ## ######   ## ## ##    ##
         ##        ##   ##  ##       ##  ####    ##
         ##         ## ##   ##       ##   ###    ##
         ########    ###    ######## ##    ##    ##

*/
  if ($('#top-event')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    let mySwiper = new Swiper('#top-event', {
      touchRatio: 0, // タッチ無効
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: false, // ループ
      slidesPerView: 4, //表示数変更
      slidesPerGroup: 4, //スライド単位変更
      spaceBetween: 10, //スライド同士の間隔を空ける
      preloadImages: false, // スライド内の画像を読み終えてから開始
      grabCursor: true, // 掴みカーソル
      simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      pagination: {
        // ページャーオプション
        el: '.event-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function(index, className) {
          return '<div class="' + className + '"></div>'
        }
      },
      navigation: {
        nextEl: '.event-button.swiper-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.event-button.swiper-button-prev' // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        1420: {
          slidesPerView: 3, //表示数変更
          slidesPerGroup: 4 //スライド単位変更
        },
        768: {
          slidesPerView: 3, //表示数変更
          slidesPerGroup: 4 //スライド単位変更
        }
      }
    })
  }

  /*

          ######   ######  ##     ##  #######   #######  ##
         ##    ## ##    ## ##     ## ##     ## ##     ## ##
         ##       ##       ##     ## ##     ## ##     ## ##
 #######  ######  ##       ######### ##     ## ##     ## ##
               ## ##       ##     ## ##     ## ##     ## ##
         ##    ## ##    ## ##     ## ##     ## ##     ## ##
          ######   ######  ##     ##  #######   #######  ########

*/
  if ($('#top-sch')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    let mySwiper = new Swiper('#top-sch', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },

      pagination: {
        // ページャーオプション
        el: '.sch-pagination', // ページャーを呼び出す要素
        type: 'fraction' // bullets,fraction(現ページ/ページ数),progressbar,custom
      },
      navigation: {
        nextEl: '.sch-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.sch-button-prev' // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以下の環境時の設定
        728: {}
      }
    })
  }

  /*

       #### ##    ## ########  #######
        ##  ###   ## ##       ##     ##
        ##  ####  ## ##       ##     ##
        ##  ## ## ## ######   ##     ##
        ##  ##  #### ##       ##     ##
        ##  ##   ### ##       ##     ##
       #### ##    ## ##        #######

*/
  if ($('#info-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    let mySwiper = new Swiper('#info-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true // クリックでジャンプ可能にする
      }
    })
  }

  /*

  #######  ########
 ##     ## ##     ##
 ##     ## ##     ##
 ##     ## ########
 ##     ## ##
 ##     ## ##
  #######  ##

*/
  // オープニング終了関数
  function opEnd() {
    $('#op').removeClass('active')
    $('.op-stay').addClass('active')
    topSwiper.slideTo(1)
  }

  if ($('#op')[0]) {
    if (!$.cookie('op') || location.hash === '#op') {
      // Cookieがなかったらオープニング終了を待つ
      $.cookie('op', 1, { expires: 1 / 24, path: '/' }) //Cookie定義
      $('#op')
        .find('.anime')
        .addClass('active')
      $('#op-timer').on('transitionend webkitTransitionEnd animationend webkitAnimationEnd', function() {
        opEnd()
      })
    } else {
      //Cookieがあったらオープニングなし
      $('#op').addClass('quik')
      opEnd()
    }
  }

  /*
██       ██████  ███████  █████  ██████
██      ██    ██    ███  ██   ██ ██   ██
██      ██    ██   ███   ███████ ██   ██
██      ██    ██  ███    ██   ██ ██   ██
███████  ██████  ███████ ██   ██ ██████
*/
  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  /*

       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######

*/
  function trunk8() {
    $('.js-t8,.bread').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  /*

  ######   ######  ########   #######  ##       ##       ########     ###    ########
 ##    ## ##    ## ##     ## ##     ## ##       ##       ##     ##   ## ##   ##     ##
 ##       ##       ##     ## ##     ## ##       ##       ##     ##  ##   ##  ##     ##
  ######  ##       ########  ##     ## ##       ##       ########  ##     ## ########
       ## ##       ##   ##   ##     ## ##       ##       ##     ## ######### ##   ##
 ##    ## ##    ## ##    ##  ##     ## ##       ##       ##     ## ##     ## ##    ##
  ######   ######  ##     ##  #######  ######## ######## ########  ##     ## ##     ##

*/
  // eslint-disable-next-line no-unused-vars
  const psL = new PerfectScrollbar('.scroll-box.left')
  // eslint-disable-next-line no-unused-vars
  const psR = new PerfectScrollbar('.scroll-box.right')
})
